import { Module } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { LegacyRoute } from '@/modules/legacy/constants';
import { LegacyPathName } from '@/modules/legacy/constants';
import { RouteNames } from '@/modules/legacy/legacy.constants';

const DashboardDetailPage = () =>
  import(
    /* webpackChunkName: "dashboard-detail-page" */ '@/modules/legacy/dashboards/pages/DashboardDetailPage.vue'
  );
const LegacyReportStudioDetailPage = () =>
  import(
    /* webpackChunkName: "legacy-report-studio-detail-page" */ '@/modules/legacy/reportstudio/pages/ReportStudioDetailPage.vue'
  );
const IntegrationsPage = () =>
  import(
    /* webpackChunkName: "integrations-page" */ '@/modules/legacy/integrations/pages/IntegrationsPage.vue'
  );

const ReportStudioDetailPage = () =>
  import(
    /* webpackChunkName: "report-studio-detail-page1" */ '@/modules/ta/reportstudio/pages/ReportStudioDetailPage.vue'
  );

export const fullFrameLegacyRouter = [
  PageRouteConfig.factory(
    {
      path: `/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: LegacyPathName.REPORTSTUDIOVIEW,
      component: LegacyReportStudioDetailPage,
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/nui/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: 'new_' + LegacyPathName.REPORTSTUDIOVIEW,
      component: ReportStudioDetailPage,
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/fav/${LegacyRoute.REPORTSTUDIO}/:id`,
      name: 'fav_' + LegacyPathName.REPORTSTUDIOVIEW,
      component: LegacyReportStudioDetailPage,
      props: {
        isFavorite: true,
      },
    },
    Module.REPORTSTUDIO
  ),
  PageRouteConfig.factory(
    {
      path: `/${LegacyRoute.QUICKREPORT}`,
      name: LegacyPathName.QUICKREPORT,
      component: () =>
        import(
          /* webpackChunkName: "quickreport-legacy-page" */ '@/modules/legacy/quickreport/pages/QuickReportLegacyPage.vue'
        ),
    },
    Module.QUICKREPORT
  ),
];

export const rightFrameLegacyRouter = [
  {
    path: `/${LegacyRoute.DASH}/:id`,
    name: LegacyPathName.DASHBOARDVIEW,
    component: DashboardDetailPage,
  },
  {
    path: `/fav/${LegacyRoute.DASH}/:id`,
    name: 'fav_' + LegacyPathName.DASHBOARDVIEW,
    component: DashboardDetailPage,
    props: {
      isFavorite: true,
    },
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}`,
    name: RouteNames.INTEGRATIONS,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/mappings/:type`,
    name: RouteNames.INTEGRATIONS_MAPPINGS,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/configure/:type`,
    name: RouteNames.INTEGRATIONS_CONFIGURE,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/addFileIntegration`,
    name: RouteNames.INTEGRATIONS_FILE_INTEGRATION,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/updateFileIntegration/:serviceConnectionId`,
    name: RouteNames.INTEGRATIONS_UPDATE_FILE_INTEGRATION,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/addSalesforceIntegration`,
    name: RouteNames.INTEGRATIONS_SALESFORCE_INTEGRATION,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/updateSalesforceIntegration/:serviceConnectionId`,
    name: RouteNames.INTEGRATIONS_UPDATE_SALESFORCE_INTEGRATION,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/webhook/:webhookType`,
    name: RouteNames.INTEGRATIONS_WEBHOOK,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/activityLog/:type`,
    name: RouteNames.INTEGRATIONS_ACTIVITY_LOG,
    component: IntegrationsPage,
  },
  {
    path: `/${LegacyRoute.INTEGRATIONS}/:id/activityLogResult/:type/:batch_log_id/:batch_id`,
    name: RouteNames.INTEGRATIONS_ACTIVITY_RESULT_VIEW,
    component: IntegrationsPage,
  },
];

export const billingRouter = PageRouteConfig.factory(
  [
    {
      path: '/billing',
      name: 'billing',
      component: () =>
        import(
          /* webpackChunkName: "billing-page"*/ '../core/billing/pages/LegacyBillingInfoPage.vue'
        ),
    },
    {
      path: '/billing/address',
      name: 'billingaddress',
      component: () =>
        import(
          /* webpackChunkName: "billingaddress-page"*/ '../core/billing/pages/LegacyBillingAddressPage.vue'
        ),
    },
    {
      path: '/billing/creditcard',
      name: 'billingcreditcard',
      component: () =>
        import(
          /* webpackChunkName: "billingcreditcard-page"*/ './billing/pages/BillingCreditcardPage.vue'
        ),
    },
  ],
  Module.BILLING
);

export const goalsRouteConfig = PageRouteConfig.factory(
  [
    {
      path: `/${LegacyRoute.GOALS}`,
      name: LegacyPathName.GOALS,
      component: () =>
        import(/* webpackChunkName: "goals-page"*/ '@/modules/ta/goal/pages/GoalsPage.vue'),
    },
  ],
  Module.GOAL
);
